import React from 'react';
import { useSubscription } from '../contexts/SubscriptionContext';
import { useAuth } from '../contexts/AuthContext';
import SubscriptionModal from './SubscriptionModal';

export const GlobalSubscriptionModal: React.FC = () => {
    const { isSubscriptionModalOpen, closeSubscriptionModal } = useSubscription();
    const { refreshUser } = useAuth();

    const handleSubscriptionSuccess = async () => {
        closeSubscriptionModal();
        // The SubscriptionModal will update the API key immediately from the response
        // Still refresh user after a delay to ensure everything is synced
        setTimeout(async () => {
            await refreshUser();
        }, 1000); // 1 second delay for any additional sync
    };

    if (!isSubscriptionModalOpen) {
        return null;
    }

    return (
        <SubscriptionModal
            open={isSubscriptionModalOpen}
            onClose={closeSubscriptionModal}
            onSuccess={handleSubscriptionSuccess}
        />
    );
}; 